// editor strings (es). Machine-drafted — review with a native speaker before launch.
const editor = {
	editor: {
		// Header / top toolbar
		backToDashboard: 'Volver al panel',
		cardTitlePlaceholder: 'Título de la tarjeta',
		previewCard: 'Vista previa',
		invite: 'Invitar',
		sendCard: 'Enviar tarjeta',
		saveChanges: 'Guardar cambios',

		// Left sidebar tool labels
		badgeNew: 'NUEVO',
		changeCover: 'Cambiar portada',
		coverType: 'Portada',
		coverStatic: 'Imagen fija',
		coverDynamic: 'Dinámica',
		coverStaticConfirm: '¿Cambiar a una portada fija? Se quitarán los textos, logotipos y etiquetas de la portada.',
		coverRemoveImage: 'Quitar imagen de portada',
		addMessage: 'Agregar mensaje',
		addImage: 'Agregar imagen',
		aiImage: 'Imagen con IA',
		background: 'Fondo',
		addGif: 'Agregar GIF',
		addVideo: 'Agregar video',
		music: 'Música',
		callToAction: 'Llamada a la acción',

		// Autosave notification
		autosaveSaving: 'Guardando ...',
		autosaveSaved: 'Guardado automáticamente',
		autosaveError: '¡Error al guardar automáticamente!',
		close: 'Cerrar',

		// Font tool
		chooseColor: 'Elegir color',
		selectFont: 'Seleccionar fuente',
		showMore: 'Mostrar más',
		showLess: 'Mostrar menos',

		// Text effect tool
		effects: 'Efectos',
		fontStyles: 'Estilos de fuente',
		effectNone: 'Ninguno',
		effectHollow: 'Hueco',
		effectLift: 'Elevado',
		effectShadow: 'Sombra',
		effectNeon: 'Neón',
		effectGlitch: 'Glitch',
		effectSplice: 'Empalme',
		backToFontTool: 'Volver a la herramienta de fuente',

		// Image tool
		searchPhotos: 'Buscar fotos',
		search: 'Buscar',
		designOnCanva: 'Diseñar en Canva',
		uploadImage: 'Subir imagen',
		uploading: 'Subiendo...',

		// GIF tool
		searchUpload: 'Buscar / Subir',
		embedLink: 'Insertar enlace',
		searchGifs: 'Buscar GIF',
		uploadGif: 'Subir GIF',
		trending: 'Tendencias',
		pasteGifUrl: 'Pega la URL del GIF aquí...',
		loading: 'Cargando...',
		addGifButton: 'Agregar GIF',
		gifUrlHint: 'Pega un enlace directo a un archivo GIF (terminado en .gif) o una URL de imagen compatible.',

		// Video tool
		videoTabAdd: 'Agregar video',
		videoTabRecord: 'Grabar',
		videoTabMyVideos: 'Mis videos',
		videoAddHint: 'Pega una URL de YouTube, Vimeo o video directo, o sube un archivo de video.',
		videoUrlPlaceholder: 'https://...',
		add: 'Agregar',
		uploadVideo: 'Subir video',
		videoSupportedHint: 'Compatible: YouTube, Vimeo, subidas MP4/WebM.',
		noVideosUploaded: 'Aún no se han subido videos.',
		confirmDeleteVideo: '¿Estás seguro de que deseas eliminar este video?',
		videoPreview: 'Vista previa del video',
		deleteSelectedVideo: 'Eliminar video seleccionado',

		// Music tool
		musicUploaded: 'Subido',
		musicLibrary: 'Biblioteca',
		musicUpload: 'Subir',
		searchTracks: 'Buscar pistas...',
		loadingTracks: 'Cargando pistas...',
		noTracksFound: 'No se encontraron pistas',
		dropAudioHere: 'Suelta el archivo de audio aquí',
		audioFormats: 'MP3, WAV u OGG',
		moodHappy: 'Alegre',
		moodSad: 'Triste',
		moodRelaxing: 'Relajante',
		moodEnergetic: 'Enérgico',
		moodRomantic: 'Romántico',
		moodEpic: 'Épico',
		moodChill: 'Chill',
		moodUplifting: 'Inspirador',

		// Call to action panel
		createCta: 'Crear una llamada a la acción',
		buttonLink: 'Enlace del botón (URL)',
		buttonText: 'Texto del botón',
		buttonColor: 'Color del botón',
		textColor: 'Color del texto',
		borderStyle: 'Estilo del borde',

		// Video card sidebar panel
		videoCard: 'Tarjeta de video',
		videoCardIntro:
			'Diseña la portada de tu tarjeta y luego comparte el enlace de invitación para que los colaboradores puedan grabar o subir sus mensajes de video.',
		shareInviteLink: 'Compartir enlace de invitación',
		shareInviteLinkHint: 'Copia este enlace y envíalo a cualquier persona que quieras que aporte un video a esta tarjeta.',
		linkCopied: '¡Enlace copiado!',
		copyInviteLink: 'Copiar enlace de invitación',
		howItWorks: 'Cómo funciona',
		videoCardStep1: 'Diseña la portada y las páginas de tu tarjeta con el editor',
		videoCardStep2: 'Guarda y copia el enlace de invitación para compartirlo con los colaboradores',
		videoCardStep3: 'Los colaboradores graban o suben videos mediante el enlace',
		videoCardStep4:
			'Ve al panel de Tarjetas de video para configurar ajustes, revisar envíos, renderizar y enviar',
		videoCardManageHint:
			'Gestiona los envíos, establece fechas límite, reordena los videos y renderiza el video final desde el',
		videoCardsDashboard: 'Tarjetas de video',

		// Merge tags panel
		createWorkflowTitle: 'Crear flujo de trabajo con integraciones',
		beta: 'Beta',
		createWorkflowDesc:
			'Conecta tus aplicaciones en minutos. Crea cualquier flujo de trabajo que imagines con Zapier o Pabbly Connect. Automatiza tus procesos e intégralos con tus aplicaciones favoritas para lograr más enfoque y menos frustración.',
		createZapierWorkflow: 'Crear flujo de Zapier',
		createPabblyWorkflow: 'Crear flujo de Pabbly Connect',
		or: 'O',
		sendViaEmailPlatform: 'Enviar a través de tu plataforma de correo',
		personalisedLinkDesc:
			'Obtén un enlace personalizado con etiquetas de combinación formateadas para tu plataforma de correo (SendGrid, Brevo, HubSpot, Mailchimp).',
		getPersonalisedLink: 'Obtener enlace personalizado',
		getEmbedCode: 'Obtener código de inserción para correo',
		customizeAndSendBulk: 'Personalizar y enviar en masa',
		customizeAndSendBulkDesc:
			'Con %{app} puedes personalizar tus tarjetas. Crea una tarjeta y envíala a todos tus contactos usando etiquetas de combinación.',
		uploadCsv: 'Subir CSV',
		selectFromLists: 'SELECCIONAR DE LAS LISTAS',
		clearAll: 'Borrar todo',
		noCsvUploaded: 'Aún no has subido un archivo csv. Comienza subiendo un archivo desde tu dispositivo.',
		deleteCsv: 'Eliminar CSV',

		// Upload CSV modal
		uploadCsvTitle: 'Sube tu archivo CSV aquí',
		uploadCsvDesc:
			'Una vez que subas tu CSV, %{app} asignará tus datos a las etiquetas de combinación disponibles junto con etiquetas personalizadas para que personalices cada tarjeta y envíes tarjetas a tantos contactos como quieras',
		cancel: 'Cancelar',
		next: 'Siguiente',

		// Invite collaborators panel
		backToMain: 'Volver al inicio',
		inviteCollaborators: 'Invitar colaboradores',
		tabDirectLink: 'Enlace directo',
		tabEmail: 'Correo electrónico',
		tabSocial: 'Redes sociales',

		// Text fallback / merge tag toolbar
		mergeTags: 'Etiquetas de combinación',
		newMergeTag: 'Nueva etiqueta',
		fromSource: 'De %{source}',
		csv: 'csv',
		// Card format + invitation event tool
		format: {
			tool: 'Formato y evento',
			title: 'Formato de la tarjeta',
			single: 'Una página',
			singleDesc: 'Una sola página.',
			double: 'Frente y reverso',
			doubleDesc: 'Dos páginas: frente y reverso.',
			folded: 'Tarjeta plegable (4 páginas)',
			foldedDesc: 'Tarjeta clásica de varias páginas.',
			front: 'Frente',
			back: 'Reverso',
			card: 'Tarjeta',
			pageLimit: 'Este formato de tarjeta permite como máximo %{max} página(s).',
			tooManyPages: 'Esta tarjeta tiene más páginas de las que permite un formato de %{max} página(s). Elimina algunas primero.',
		},
		event: {
			toggle: 'Esta tarjeta es una invitación',
			eventTitle: 'Título del evento',
			start: 'Comienza',
			end: 'Termina (opcional)',
			timezone: 'Zona horaria',
			inPerson: 'Presencial',
			online: 'En línea',
			address: 'Dirección',
			hostNote: 'Nota del anfitrión',
			allowGuests: 'Permitir invitados (+1)',
			save: 'Guardar invitación',
			saved: 'Invitación guardada',
			errorTitle: 'Error',
			saveFailed: 'No se pudieron guardar los cambios',
			errors: {
				titleRequired: 'Ingresa un título para el evento.',
				titleTooLong: 'El título debe tener 200 caracteres o menos.',
				startRequired: 'Elige una fecha y hora de inicio.',
				endInvalid: 'Ingresa una fecha y hora de fin válidas.',
				endBeforeStart: 'El fin no puede ser anterior al inicio.',
				timezoneInvalid: 'Elige una zona horaria válida.',
				urlInvalid: 'Ingresa un enlace http(s) válido.',
				hostNoteTooLong: 'La nota debe tener 1000 caracteres o menos.',
			},
		},
	} as Record<string, any>,
};
export default editor;
